<article class="cardscan" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <div class="process">
      <sot-backbtn (click)="back()"></sot-backbtn>
      <sot-stepper activeStep="card"></sot-stepper>
      <div>&nbsp;</div>
    </div>
  </header>

  <div class="content" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
    <div class="box">
      <ng-container>
        <h3 langkey="process_start_card_scann">Jetzt scannen</h3>
        <div class="icon" inlineSVG="sot/sot-icon.svg#sot-cardscan" [setSVGAttributes]="{class: 'box-icon'}"></div>
        <p langkey="process_start_card_scann_text">Bitte die Vorgangskarte unten auf den Scanner legen</p>
      </ng-container>
      <div class="downpay" inlineSVG="sot/sot-icon.svg#sot-down_arrows" [setSVGAttributes]="{class: 'arrows'}"></div>
    </div>
  </div>
</article>